import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, FormArray } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Lang, Res } from 'src/app/models';
import { ApiOrgStructuresService, LanguageService, NotificationService, ValidatorsService } from 'src/app/services';
import { OrgStructureValidator } from './org-structure-actions.validation';

@Component({
  selector: 'app-org-structrure-actions',
  templateUrl: './org-structrure-actions.component.html',
  styleUrls: ['./org-structrure-actions.component.css']
})
export class OrgStructrureActionsComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  errorMessages: any;
  loading: boolean;
  structureData: any;
  departments: any;
  positions: any;
  structureId: string;
  departmentName: Lang;
  userData: any;

  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }

  form: UntypedFormGroup = this.fb.group({
    department_id:[null],
    position_id: [null, this.validator.position_id]
  });


  @Input() set data(value) {

    if (value != null) {
      this.structureId = value.structure_id;
    }
  }

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private notification: NotificationService,
    private apiOrgStructure: ApiOrgStructuresService,
    private validator: OrgStructureValidator,
    private validatorService: ValidatorsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    this.getPositions();
    this.getDepartments();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * @param searchValue 
   */
  getDepartments(searchValue: string = ''): void {

    this.progressRef.start();
    this.loading = true;

    let params = {
      "filter": {}
    }

    this.subscriptions.add(
      this.apiOrgStructure.getReferences(params, 'orgs_departments').subscribe((response: Res) => {

        if (response != null) {

          this.departments = response.result;
          if (this.userData) this.form.controls.department_id.setValue(this.userData.department);
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }


  /**
   * 
   */
  getPositions(): void {

    this.progressRef.start();
    this.loading = true;


    let params = {
      filter: {
        get_all_positions: true
      }
    }

    this.subscriptions.add(
      this.apiOrgStructure.getReferences(params, 'orgs_positions').subscribe((response: Res) => {console.log("NAME: ", response);
      

        if (response != null) {

          this.positions = response.result;
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }

  /**
   * 
   */
  onCreate(): void {

    let form = { ...this.form.value }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiOrgStructure.create(form).subscribe((response: Res) => {

        if (response != null) {

          this.notification.show('success', 'Роль успешно создана!');
          this.activeModal.close(response);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }


  /**
  * 
  */
  onEdit(): void {

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(

      this.apiOrgStructure.edit(this.structureId).subscribe((response: Res) => {
        console.log('[RESPONSE] ORG_ROLE_EDIT: ', response);

        if (response != null) {

          this.structureData = { ...response.result };

          this.setDataInForm(response.result);
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }


  /**
   * 
   */
  setDataInForm(data: any): any {

    this.departmentName = data.name;

    this.form.controls.id.setValue(data.id);
    this.form.controls.department_id.setValue(data.parent_id);
  }


  /**
   * 
   */
  onUpdate() {

    let form = { ...this.form.value }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiOrgStructure.update(form).subscribe((response: Res) => {
        console.log('[RESPONSE] updateUserInfo: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.activeModal.close(true);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
  * 
  * @param field 
  * @param type 
  */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

}
